import React, { useEffect, useState } from "react";
import "../rejectDialog/RejectDialog.css";

const StatusConfirmDialog = ({
  open,
  title = "Are you sure you want to change status?",
  message = "",
  confirmLabel = "Confirm",
  onConfirm,
  onCancel,
}) => {
  const [comment, setComment] = useState("");

  useEffect(() => {
    if (open) setComment("");
  }, [open]);

  if (!open) return null;

  return (
    <div className="reject-modal-overlay" onClick={onCancel}>
      <div
        className="reject-modal-content"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="reject-modal-header">
          <h2 className="reject-modal-title">{title}</h2>
          <button
            type="button"
            className="reject-modal-close"
            onClick={onCancel}
            aria-label="Close"
          >
            ×
          </button>
        </div>

        <div className="reject-modal-body">
          {message ? <p className="reject-modal-message">{message}</p> : null}
          <div className="reject-modal-label">Add Note / Comments</div>
          <textarea
            className="reject-modal-textarea"
            placeholder="Write comments (optional)"
            value={comment}
            onChange={(e) => setComment(e.target.value)}
          />
        </div>

        <div className="reject-modal-footer">
          <button
            type="button"
            className="reject-modal-btn cancel"
            onClick={onCancel}
          >
            Cancel
          </button>
          <button
            type="button"
            className="reject-modal-btn reject"
            onClick={() => onConfirm(comment.trim())}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default StatusConfirmDialog;

export const STATUS_LABELS = {
  // Numeric ids (legacy)
  1: "In Process",
  3: "Pending For Approval",
  4: "Approved",
  5: "Rejected",
  7: "Renewal",
  20: "Discrepancies Company - Assigned to Company",

  // Canonical status names
  drafts: "Draft",
  draft: "Draft",
  application_submitted_by_company_user_to_company: "In Review",
  application_sent_to_discrepancy_by_company:
    "Discrepancies Company - Assigned to Company",
  dicrepancy_application_assigned_to_company_user:
    "Discrepancies Company - Assigned to Employee",
  in_process: "In Process",
  // API sometimes uses "discrepancy_*" and sometimes "descrepancy_*"
  discrepancy_GB_GB: "Discrepancies GB - Assigned to GB",
  descrepancy_GB_GB: "Discrepancies GB - Assigned to GB",
  discrepancy_GB_Company: "Discrepancies GB - Assigned to Company",
  descrepancy_GB_Company: "Discrepancies GB - Assigned to Company",
  discrepancy_GB_Employee: "Discrepancies GB - Assigned to Employee",
  descrepancy_GB_Employee: "Discrepancies GB - Assigned to Employee",
  approved: "Approved",
  rejected: "Rejected",
  renewal: "Renewal",

  // Other aliases still seen in the app
  pending: "Pending",
  pending_for_approval: "Pending For Approval",
  discrepancies: "Discrepancies",
  assign_to_company: "Discrepancies Company - Assigned to Company",
  application_submitted_to_company: "In Review",
};

/** Human-readable label for a status slug/id (e.g. in_process → In Process). */
export const formatStatusLabel = (status) => {
  if (status == null || status === "") return "—";
  const key = String(status).trim();
  if (STATUS_LABELS[key]) return STATUS_LABELS[key];
  if (STATUS_LABELS[key.toLowerCase()]) return STATUS_LABELS[key.toLowerCase()];
  // Fallback: snake_case / kebab-case → Title Case
  return key
    .replace(/[_-]+/g, " ")
    .replace(/\b\w/g, (c) => c.toUpperCase());
};

/** Replace known status slugs inside free-text (e.g. audit descriptions). */
export const formatStatusInText = (text) => {
  if (!text) return text || "—";
  let result = String(text);
  const keys = Object.keys(STATUS_LABELS)
    .filter((k) => Number.isNaN(Number(k)))
    .sort((a, b) => b.length - a.length);
  keys.forEach((slug) => {
    const re = new RegExp(
      `\\b${slug.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")}\\b`,
      "gi"
    );
    result = result.replace(re, STATUS_LABELS[slug]);
  });
  return result;
};

export const STATUS_ROUTES = {
  1: "/in-process-applications",
  3: "/pending-applications",
  4: "/approved-applications",
  5: "/rejected-applications",
  7: "/renewals",
  20: "/discrepancies",
  in_process: "/in-process-applications",
  pending_for_approval: "/pending-applications",
  approved: "/approved-applications",
  rejected: "/rejected-applications",
  discrepancy_GB_GB: "/discrepancies",
  renewal: "/renewals",
  assign_to_company: "/discrepancies",
};

export const getStatusRoute = (status) => STATUS_ROUTES[status] || null;
